import firebase from "firebase";

const firebaseConfig = {
  apiKey: "AIzaSyB3LCN-mLHralyQRFnXJqhcNM6rB4hXhW0",
  authDomain: "epic-28be2.firebaseapp.com",
  projectId: "epic-28be2",
  storageBucket: "epic-28be2.appspot.com",
  messagingSenderId: "624574584165",
  appId: "1:624574584165:web:e130ad8772c71c4d63bd8c",
};
const firebaseApp = firebase.initializeApp(firebaseConfig);
const database = firebaseApp.firestore();
const storage = firebase.storage();
export default database;
export { storage };
